import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import Image from './login-register.jpg';
import {PostData} from '/home/sygitech/Downloads/v-1.5/jumbo-react/source/src/Service/PostData';

export default class Login4 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email : '',
            password : ''
        };
        console.log('this.state.constructor', this.state);
        this.onChange = this.onChange.bind(this);
    }
    /*componentDidMount() {
        this.setState({message: ''});
        this.setState({redirectToReferrer: false});
    }*/
    state = {
        message: '',
        redirectToReferrer: false,
    };
    loginUser(e){
        e.preventDefault();
        console.log('this.state', this.state);
        if(this.state.email && this.state.password) {
            PostData('login', this.state).then((result) => {
                let responseJson = result;
                let msg = '';
                console.log("DATAAAAAAAAAAA",responseJson.error);
                if(responseJson.error != '' && responseJson.error != undefined){
                    console.log("IFFF");
                    this.setState({redirectToReferrer: false});
                    msg = "Sorry, Something went wrong. Please try again!!";  
                } else {
                    console.log("ELSESE NOOTANS");
                    if(responseJson.Response.Data.id != '' && responseJson.Response.Data.id == 4 && responseJson.Response.Status == 200) {
                            sessionStorage.setItem('userData',JSON.stringify(responseJson.Response.Data));
                            this.setState({redirectToReferrer: true});
                            console.log("IFFFFFF");
                    } else if(responseJson.Response.Data.id != '' && responseJson.Response.Data.id != 4) {
                        console.log("ELSEEEIFFFFFFFFFFF");
                        this.setState({redirectToReferrer: false});
                        responseJson.Response.Message = "User is not admin";
                    } else {
                        console.log("ELSEEE");
                        this.setState({redirectToReferrer: false});
                    }
                    msg = responseJson.Response.Message;
                }
                this.setState({message: msg});
            });
        }
    }


    showMessage(){
        return(
                <div>
                    <h4>{this.state.message}</h4>
                </div>
        )
    }
    onChange(e){
        this.setState({[e.target.name]:e.target.value});
    }
   render() {
        if(sessionStorage.getItem('userData')){
            return ( <Redirect to={'/darsham/dashboard/default'}/> );
        }
        if(this.state.redirectToReferrer == true) {
            return ( <Redirect to={'/darsham/dashboard/default'}/> );
        }
        return (
           
                <div
                    className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3" style={{backgroundImage:"url("+Image+")"}}>
                    <div className="login-content">
                        {!this.state.redirectToReferrer && this.showMessage()}
                        <div className="login-header">
                            <h3 className="m-b-20">Sign In </h3>
                        </div>

                        <div className="login-form">
                            <form method="post" onSubmit={this.loginUser.bind(this)}>
                                <fieldset>
                                    <div className="form-group">
                                        <input name="email" id="email" className="form-control form-control-lg"
                                               placeholder="Email" type="email" onChange={this.onChange} required/>
                                    </div>
                                    <div 
                                        className="form-group">
                                        <input name="password" id="password" className="form-control form-control-lg"
                                               placeholder="Password" type="password" onChange={this.onChange} required/>
                                    </div>
                                    <div className="form-group d-flex justify-content-between align-items-center">
                                        <label className="custom-control custom-checkbox float-left">
                                               <input type="checkbox" className="custom-control-input"/>
                                            <span className="custom-control-indicator"/>
                                            <span className="custom-control-description">Remember me</span>
                                        </label>

                                        <div>
                                            <a className="text-primary" href="#/forgotpassword"
                                               title="Reset Password">Forgot
                                                your password</a>
                                        </div>
                                    </div>
                                    <button type="submit" className="btn jr-btn-rounded btn-primary btn-rounded" >
                                        Sign In
                                    </button>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            
        );
   }
};




// WEBPACK FOOTER //
// ./app/routes/appModule/routes/login/Login4.js